<script>
import { mapState, mapMutations } from 'vuex';
import { get } from 'lodash';

import LecturesMenu from './LecturesMenu';
import config from '@/config/config';

export default {
  name: 'ComponentsCourseFinish',
  components: {
    LecturesMenu,
  },
  computed: {
    ...mapState(config.app, [
      'course',
    ]),
    finalWords() {
      return get(this, 'course.finalWords', null);
    },
    flow() {
      return config.initial.course;
    },
  },
  methods: {
    ...mapMutations(config.app, [
      'setCurrentCourse',
    ]),
  },
};
</script>
<template>
    <div id="course-video">
        <LecturesMenu />
        <div class="wrapper">
            <button class="btn w-auto" @click="setCurrentCourse(flow.lecture)">
                powrót
            </button>
            <div v-html="finalWords" class="mt-5 mb-5" />
        </div>
    </div>
</template>
